import React, { useEffect } from 'react';

const VARIANTS = {
    success: {
        bg: "bg-green-100",
        border: "border-green-400",
        text: "text-green-900",
        icon: (
            <svg className="w-5 h-5 flex-shrink-0 text-green-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" fill="currentColor" opacity=".2" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
        ),
    },
    error: {
        bg: "bg-red-100",
        border: "border-red-400",
        text: "text-red-900",
        icon: (
            <svg className="w-5 h-5 flex-shrink-0 text-red-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" fill="currentColor" opacity=".2" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 9l-6 6m0-6l6 6" /></svg>
        ),
    },
    warning: {
        bg: "bg-yellow-100",
        border: "border-yellow-400",
        text: "text-yellow-900",
        icon: (
            <svg className="w-5 h-5 flex-shrink-0 text-yellow-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" fill="currentColor" opacity=".2" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01" /></svg>
        ),
    },
    info: {
        bg: "bg-blue-100",
        border: "border-blue-400",
        text: "text-blue-900",
        icon: (
            <svg className="w-5 h-5 flex-shrink-0 text-blue-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" fill="currentColor" opacity=".2" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01" /></svg>
        ),
    },
};

export default function Toaster({ type = 'success', message, onClose }) {
    useEffect(() => {
        const timer = setTimeout(onClose, 3000);
        return () => clearTimeout(timer);
    }, [onClose]);

    const variant = VARIANTS[type] || VARIANTS.success;

    return (
        <div className={`fixed top-5 right-5 z-50 w-full max-w-xs flex items-center border-l-4 shadow-lg px-4 py-3 rounded ${variant.bg} ${variant.border}`}>
            {variant.icon}
            <span className={`ml-3 flex-1 font-medium ${variant.text}`}>{message}</span>
            <button className="ml-3 p-1 focus:outline-none text-gray-400 hover:text-gray-700" onClick={onClose}>&times;</button>
        </div>
    );
}
